export const businessToolData = {
  navItems: [
    { label: "サービス概要", anchor: "#overview" },
    { label: "開発例", anchor: "#development-examples" },
    { label: "進め方", anchor: "#development-flow" },
    { label: "対応範囲", anchor: "#scope" },
    { label: "保守", anchor: "#maintenance" },
    { label: "料金", anchor: "#pricing" },
    { label: "よくある質問", anchor: "#faq" },
  ],

  hero: {
    breadcrumbs: [
      { label: "ホーム", href: "/" },
      { label: "サービス", href: null },
      { label: "業務ツール・システム開発", href: null },
    ],
    serviceLabel: "SERVICE 04",
    serviceSubLabel: "BUSINESS TOOL & SYSTEM DEVELOPMENT",
    mainCopy: "大きなシステムではなく、\n現場に必要な仕組みをつくる",
    description:
      "申込、予約、会員管理、問い合わせ対応、業務自動化など、日々の仕事に必要なツールを設計・開発します。業務を整理し、必要な機能を見極め、実際に使い続けられる形に整えます。",
    tags: [
      { label: "中小企業・地域団体向け", icon: "ri-building-2-line" },
      { label: "小規模・中規模開発", icon: "ri-stack-line" },
      { label: "要件整理から対応", icon: "ri-file-list-3-line" },
      { label: "保守・改善対応", icon: "ri-settings-3-line" },
    ],
    image:
      "https://readdy.ai/api/search-image?query=Warm%20abstract%20organic%20background%20with%20soft%20flowing%20layered%20shapes%20in%20cream%20beige%20and%20warm%20neutral%20tones%2C%20subtle%20paper%20texture%2C%20delicate%20grid%20lines%20and%20abstract%20form%20field%20outlines%20fading%20into%20the%20composition%2C%20gentle%20curved%20geometric%20forms%20suggesting%20business%20process%20flow%2C%20warm%20orange%20amber%20accents%2C%20no%20people%20no%20faces%2C%20editorial%20abstract%20suitable%20for%20hero%20section%2C%20calm%20professional%20atmosphere%20with%20warm%20light%20tones&width=1920&height=1080&seq=business-tool-hero-bg&orientation=landscape",
  },

  serviceOverview: {
    label: "SERVICE OVERVIEW",
    title: "業務ツール・システム開発 サービス概要",
    description:
      "このページを最後まで読まなくても、このサービスの基本的な仕組みがわかります。",
    introText:
      "業務ツール・システム開発は、大規模な基幹システムを一から構築するサービスではありません。中小企業、店舗、団体、事務局などが抱える具体的な業務課題を整理し、申込受付、予約、会員管理、問い合わせ対応、情報共有、業務自動化など、日々の仕事に必要な小規模・中規模のツールを設計・開発します。",
    items: [
      { label: "対象", value: "業務に合う既存ツールが見つからない中小企業、店舗、団体、事務局" },
      { label: "契約形態", value: "プロジェクト契約・個別見積" },
      { label: "対応領域", value: "申込、予約、会員管理、問い合わせ、情報共有、業務自動化" },
      { label: "支援内容", value: "課題整理、要件定義、設計、開発、テスト、操作説明" },
      { label: "開発規模", value: "小規模・中規模の業務ツールを中心に対応" },
      { label: "保守", value: "開発内容に応じて、月額保守をご提案" },
      { label: "訪問対応", value: "都内近郊を中心に対応" },
      { label: "継続支援", value: "必要に応じてDX顧問・事務局サポートと連携" },
    ],
  },

  challenges: {
    label: "CHALLENGES",
    title: "今の業務に合う仕組みがなく、手作業が残っていませんか",
    items: [
      {
        icon: "ri-file-transfer-line",
        title: "申込内容を手作業で転記している",
        desc: "フォーム、メール、紙などで受け付けた内容を、別の表へ転記している。",
      },
      {
        icon: "ri-calendar-check-line",
        title: "予約状況を複数の表で管理している",
        desc: "担当者ごとにファイルが分かれ、最新情報が分からなくなる。",
      },
      {
        icon: "ri-contacts-line",
        title: "会員情報の更新が煩雑",
        desc: "入会、退会、住所変更、会費状況などを複数のファイルで管理している。",
      },
      {
        icon: "ri-user-shared-line",
        title: "問い合わせ対応が属人化している",
        desc: "過去の回答や対応履歴が担当者のメールに残っている。",
      },
      {
        icon: "ri-loop-left-line",
        title: "同じ作業を何度も繰り返している",
        desc: "集計、通知、ファイル作成など、定型作業に時間がかかっている。",
      },
      {
        icon: "ri-function-line",
        title: "既存サービスでは機能が多すぎる",
        desc: "必要のない機能まで含まれ、費用や操作の負担が大きい。",
      },
    ],
  },

  about: {
    label: "ABOUT THE SERVICE",
    title: "システムをつくる前に、業務の流れを整理",
    description:
      "業務ツール・システム開発は、依頼された機能をそのままつくるサービスではありません。",
    description2:
      "まず、現在どのような業務があり、誰が、いつ、何を行い、どこで時間や手間がかかっているのかを確認します。",
    description3:
      "そのうえで、既存ツールで解決できるのか、設定や運用の見直しで改善できるのか、独自の開発が必要なのかを判断します。",
    description4:
      "開発が必要な場合も、最初からすべての機能を盛り込まず、実際に必要な範囲へ絞って設計します。",
    flowSteps: [
      "現在の業務を確認する",
      "困っている原因を整理する",
      "既存ツールで解決できるか検討する",
      "必要な機能だけを設計する",
      "小さく開発して試す",
      "実際の運用に合わせて改善する",
    ],
  },

  developmentExamples: {
    label: "DEVELOPMENT EXAMPLES",
    title: "業務ツール開発例",
    categories: [
      {
        num: "01",
        title: "申込・受付フォーム",
        icon: "ri-file-list-3-line",
        items: [
          "イベント申込",
          "セミナー受付",
          "入会申込",
          "問い合わせ受付",
          "自動返信",
          "受付内容の一覧管理",
          "担当者への通知",
        ],
        note: null,
      },
      {
        num: "02",
        title: "予約管理",
        icon: "ri-calendar-check-line",
        items: [
          "施設予約",
          "面談予約",
          "相談予約",
          "利用枠の管理",
          "予約確認メール",
          "キャンセル受付",
          "管理者用一覧",
        ],
        note: null,
      },
      {
        num: "03",
        title: "会員・顧客管理",
        icon: "ri-contacts-line",
        items: [
          "会員情報管理",
          "入退会履歴",
          "連絡先変更",
          "会費状況",
          "会員区分",
          "検索・絞り込み",
          "CSV出力",
        ],
        note: "個人情報や決済情報を扱う場合は、要件と安全性を確認したうえで対応範囲を判断します。",
      },
      {
        num: "04",
        title: "FAQ・チャットボット",
        icon: "ri-chat-smile-2-line",
        items: [
          "よくある質問",
          "利用案内",
          "施設案内",
          "会員向け問い合わせ",
          "ウェブサイト内検索",
          "問い合わせ前の自己解決支援",
        ],
        note: "AIを利用する場合も、回答内容、参照データ、個人情報の扱いを整理します。",
      },
      {
        num: "05",
        title: "業務自動化",
        icon: "ri-settings-3-line",
        items: [
          "メールの自動送信",
          "定型資料の作成",
          "スプレッドシートへの転記",
          "集計・一覧作成",
          "期限通知",
          "ファイル生成",
          "Google Apps Scriptによる自動化",
        ],
        note: null,
      },
      {
        num: "06",
        title: "ウェブサイトとの連携",
        icon: "ri-global-line",
        items: [
          "WordPressとの連携",
          "会員専用ページ",
          "申込情報の表示",
          "お知らせとの連携",
          "外部フォームとの接続",
          "API連携",
          "管理画面の追加",
        ],
        note: "対応可能かどうかは、利用サービスや外部仕様を確認して判断します。",
      },
    ],
  },

  buildOrUse: {
    label: "BUILD OR USE",
    title: "既存ツールで解決できる場合",
    description:
      "独自開発は、自由度が高い一方で、開発費、保守費、仕様変更への対応が必要になります。既存のクラウドサービスで十分に解決できる場合は、無理に開発せず、既存ツールの導入をご提案します。",
    existingTools: {
      title: "既存ツールが向いている場合",
      icon: "ri-cloud-line",
      items: [
        "一般的な予約や受付業務",
        "標準機能で十分対応できる",
        "短期間で導入したい",
        "初期費用を抑えたい",
        "サービス提供会社の保守を利用したい",
      ],
    },
    customDev: {
      title: "独自開発が向いている場合",
      icon: "ri-code-s-slash-line",
      items: [
        "業務独自の条件や手順がある",
        "複数の業務を一つにつなげたい",
        "既存ツールでは余計な作業が残る",
        "ウェブサイトや既存データと連携したい",
        "必要な機能だけに絞りたい",
      ],
    },
    bottomText: "つくることではなく、課題が解決することを優先します。",
  },

  developmentFlow: {
    label: "DEVELOPMENT FLOW",
    title: "業務を確認し、画面と動きを確かめながら進めます",
    steps: [
      {
        num: "01",
        title: "ヒアリング・業務確認",
        desc: "現在の業務、担当者、利用環境、困っていることを確認します。",
      },
      {
        num: "02",
        title: "課題整理・方針決定",
        desc: "何を改善するのか、既存ツールか独自開発かを整理します。",
      },
      {
        num: "03",
        title: "要件整理・お見積り",
        desc: "必要な機能、利用者、データ、権限、対応範囲を整理し、お見積りします。",
      },
      {
        num: "04",
        title: "画面・動作の確認",
        desc: "画面構成、入力項目、処理の流れを、図や試作品で確認します。",
      },
      {
        num: "05",
        title: "開発・テスト",
        desc: "機能を開発し、表示、動作、権限、エラー時の挙動などを確認します。",
      },
      {
        num: "06",
        title: "導入・操作説明",
        desc: "本番環境へ導入し、担当者へ操作方法と運用方法を説明します。",
      },
    ],
    centerText: "業務確認 → 要件整理 → 設計 → 開発 → テスト → 運用開始",
  },

  smallStart: {
    label: "SMALL START",
    title: "最小限の構成から開始",
    description:
      "業務ツールは、使い始めて初めて分かることがあります。そのため、最初から多くの機能を盛り込むのではなく、最も重要な業務を動かせる最小限の構成から始めます。",
    steps: [
      {
        num: "STEP 1",
        title: "まず動かす",
        desc: "中心となる機能だけを開発し、実際の担当者が使える状態にする。",
      },
      {
        num: "STEP 2",
        title: "実務で試す",
        desc: "実際の業務で使い、使いにくさや不足している機能を確認する。",
      },
      {
        num: "STEP 3",
        title: "必要な改善を加える",
        desc: "利用状況を見ながら、必要な機能だけを追加・修正する。",
      },
    ],
    note: "すべての案件で段階開発を行うとは限りません。業務内容と必要性に応じて進め方をご提案します。",
  },

  deliverables: {
    label: "DELIVERABLES",
    title: "担当者が変わっても引き継げる状態を残します",
    description:
      "動くシステムだけでなく、何のためにつくり、どのように使い、誰が管理するのかを整理して残します。",
    categories: [
      {
        title: "仕様",
        icon: "ri-file-list-3-line",
        items: [
          "開発目的",
          "対象業務",
          "主な機能",
          "利用者と権限",
          "データの扱い",
        ],
      },
      {
        title: "運用",
        icon: "ri-settings-3-line",
        items: [
          "操作手順",
          "管理者の役割",
          "日常的な更新方法",
          "問い合わせ先",
          "障害時の連絡方法",
        ],
      },
      {
        title: "技術情報",
        icon: "ri-computer-line",
        items: [
          "利用サービス",
          "外部連携",
          "アカウント・権限",
          "バックアップ",
          "保守範囲",
        ],
      },
      {
        title: "今後の改善",
        icon: "ri-lightbulb-line",
        items: [
          "未対応機能",
          "改善候補",
          "運用上の注意点",
          "次回見直し項目",
        ],
      },
    ],
  },

  scope: {
    label: "SCOPE",
    title: "小規模・中規模の業務ツールを中心に対応",
    note: "安全に対応できる範囲を明確にし、お客様と合意したうえで進めます。",
    included: {
      title: "対応する主な内容",
      items: [
        "業務課題の整理",
        "要件整理・仕様設計",
        "画面・業務フロー設計",
        "小規模なウェブシステム",
        "WordPressとの連携",
        "Google Apps Script",
        "API・外部サービス連携",
        "テスト・導入",
        "操作説明",
        "開発後の保守・改善",
      ],
    },
    excluded: {
      title: "対応が難しい、または個別判断となるもの",
      items: [
        "大規模な基幹システム",
        "金融・医療など高度な専門要件を持つシステム",
        "24時間365日の監視が必要なシステム",
        "大量アクセスを前提とするサービス",
        "高度な決済・会計処理",
        "法令上の専門要件が強いシステム",
        "ハードウェアや機器制御",
        "開発元が不明な既存システムの全面改修",
        "仕様や管理権限が確認できない外部サービス",
      ],
    },
  },

  maintenance: {
    label: "MAINTENANCE",
    title: "開発後も、継続支援します",
    description:
      "業務ツールやシステムは、公開して終わりではありません。利用サービスの仕様変更、担当者の交代、業務内容の変化などに合わせて、確認や改善が必要になります。",
    items: [
      "定期的な動作確認",
      "バックアップ",
      "軽微な不具合対応",
      "外部サービスの仕様変更確認",
      "アカウント・権限の確認",
      "操作に関する相談",
      "軽微な修正",
      "改善内容のご提案",
    ],
    priceLabel: "月額保守料金",
    price: "月額20,000円〜",
    priceNote: "保守料金は、システムの構成、外部連携、確認項目、対応時間などによって異なります。",
    additionalNote: "新しい機能の追加や大規模な仕様変更は、保守料金とは別にお見積りします。",
  },

  pricing: {
    label: "PRICE",
    title: "必要な機能と開発範囲を確認してお見積りします",
    planName: "業務ツール・システム開発",
    pricing: "個別見積",
    description: "業務内容と必要な機能を確認し、お見積りを作成します。",
    estimateItems: [
      "ヒアリング・業務整理",
      "要件整理",
      "画面・仕様設計",
      "開発",
      "テスト",
      "導入",
      "操作説明",
      "必要に応じた初期データ設定",
    ],
    priceFactors: [
      "画面数",
      "機能数",
      "利用者数",
      "権限の種類",
      "管理するデータの量と種類",
      "外部サービス連携",
      "データ移行",
      "セキュリティ要件",
      "操作説明・研修",
      "保守内容",
    ],
    note: "要件と費用をご確認いただき、合意後に開発を開始します。",
    cta: "自社・自団体の業務ツールについて相談する",
  },

  whoItIsFor: {
    label: "WHO IT IS FOR",
    title: "このような企業・団体に向いています",
    suitable: {
      title: "向いている組織",
      items: [
        "手作業や転記が多い",
        "現在の業務に合う既存ツールがない",
        "必要な機能だけを使いたい",
        "ウェブサイトや既存データと連携したい",
        "小さく始めて改善したい",
        "操作や運用まで相談したい",
        "担当者が変わっても使える状態をつくりたい",
      ],
    },
    unsuitable: {
      title: "別の方法が適している可能性がある組織",
      items: [
        "既存のクラウドサービスで十分対応できる",
        "大規模な基幹システムだけを開発したい",
        "仕様が決まっておらず、業務確認にも協力できない",
        "24時間の監視や即時復旧が必要",
        "とにかく最安価格だけを重視している",
      ],
    },
    note: "どの方法が適しているかは、ご相談内容を伺ったうえでご案内します。",
  },

  serviceGuide: {
    label: "SERVICE GUIDE",
    title: "現況に応じて、適切な支援方法をご案内します",
    services: [
      {
        name: "業務ツール・システム開発",
        tagline: "既存ツールだけでは解決できない仕組みをつくる",
        type: "プロジェクト型",
        points: [
          "個別開発",
          "要件整理",
          "画面・機能設計",
          "開発・テスト",
          "保守・改善",
        ],
        isCurrent: true,
        href: null,
      },
      {
        name: "AI・デジタル導入支援",
        tagline: "既存のAI・クラウドツールを選び、使い始める",
        type: "スポット・プロジェクト型",
        points: [
          "ツール選定",
          "初期設定",
          "ルール作成",
          "研修",
          "試行運用",
        ],
        isCurrent: false,
        href: "/service/ai-digital",
      },
      {
        name: "DX顧問・伴走型AI事務局サポート",
        tagline: "導入後も継続して課題と改善を整理する",
        type: "月額伴走型",
        points: [
          "月額伴走",
          "定例相談",
          "優先順位整理",
          "運用確認",
          "継続改善",
        ],
        isCurrent: false,
        href: "/service/dx-consultant",
      },
    ],
    note: "どの方法が適しているか分からない場合は、現在の業務と困りごとを伺ったうえでご案内します。",
  },

  faq: {
    label: "FAQ",
    title: "よくある質問",
    items: [
      {
        q: "仕様が決まっていなくても相談できますか",
        a: "はい。現在の業務や困っていることを伺い、何を改善する必要があるかを整理するところから対応します。",
      },
      {
        q: "既存のサービスと独自開発のどちらがよいか相談できますか",
        a: "はい。費用、機能、運用負担を比較し、既存サービスで十分な場合は独自開発を勧めません。",
      },
      {
        q: "小さなツールだけでも依頼できますか",
        a: "はい。申込フォーム、通知、集計、自動化など、限定された業務の改善もご相談いただけます。",
      },
      {
        q: "開発期間はどのくらいですか",
        a: "機能、画面数、外部連携、確認期間などによって異なります。要件整理後にスケジュールをご案内します。",
      },
      {
        q: "開発途中で画面や動作を確認できますか",
        a: "はい。画面構成や試作品を確認いただき、認識を合わせながら進めます。",
      },
      {
        q: "システム完成後の修正もお願いできますか",
        a: "はい。保守契約またはスポット対応としてご相談いただけます。新機能の追加や大規模改修は別途お見積りします。",
      },
      {
        q: "他社が開発したシステムの改修もできますか",
        a: "仕様、ソースコード、管理権限、利用環境を確認したうえで判断します。状態によっては対応できない場合があります。",
      },
      {
        q: "個人情報を扱うシステムも開発できますか",
        a: "扱う情報、利用人数、保存方法、安全性を確認したうえで、対応範囲を判断します。高度な専門要件がある場合は対応できないことがあります。",
      },
      {
        q: "ホームページと一緒に依頼できますか",
        a: "はい。株式会社ノーブルウェブのウェブ制作事業部と連携して対応します。",
      },
      {
        q: "AIを使ったチャットボットもつくれますか",
        a: "ご相談いただけます。利用目的、参照データ、回答精度、個人情報、運用方法を確認したうえでご提案します。",
      },
    ],
  },

  relatedServices: {
    label: "RELATED SERVICES",
    title: "開発前の整理や、導入後の改善も支援します",
    items: [
      {
        title: "DX顧問",
        desc: "会社全体の業務課題を整理し、改善を継続して支援します。",
        href: "/service/dx-consultant",
        icon: "ri-user-star-line",
      },
      {
        title: "伴走型AI事務局サポート",
        desc: "団体・会員組織の事務局運営に必要な仕組みを整理します。",
        href: "/service/ai-office",
        icon: "ri-team-line",
      },
      {
        title: "AI・デジタル導入支援",
        desc: "既存のAIやクラウドツールで解決できる場合に、選定・設定・研修を支援します。",
        href: "/service/ai-digital",
        icon: "ri-robot-line",
      },
    ],
  },

  cta: {
    label: "CONTACT",
    heading: "今の業務に、どのような仕組みが必要か一緒に考えませんか",
    description:
      "具体的な画面や機能が決まっていなくても問題ありません。現在の業務、困っていること、使っているツールを伺い、既存サービスで解決できるか、開発が必要かを整理します。",
    note: "つくることではなく、課題が解決することを優先します。",
    beforeFormPoints: [
      "仕様が決まっていない段階でも相談可能",
      "既存ツールとの比較から対応",
      "小規模な業務ツールに対応",
      "開発後の保守・改善も相談可能",
    ],
    inquiryTypes: [
      "業務ツール・システム開発について",
      "DX顧問について",
      "伴走型AI事務局サポートについて",
      "AI・デジタル導入について",
      "セミナー・講演について",
      "その他",
    ],
  },
};